export default "__VITE_ASSET__21e33ba2__"